<template>
  <div id="app">
    <div id="page_top" @click="scrollTop()"></div>
    <router-view
      :siteInfo="sites"
      :cameraInfo="cameras"
      @loadStart="loadStart"
      @loadFinish="loadFinish"
    />
    <!-- 読み込みローディングアイコンの表示 -->
    <!-- オーバーレイを掛ける部分をWrapperからmainBlockに変更 -->
    <LoadingBoxForApp
      lodingHiddenId="mainBlock"
      lodingShowMessage="しばらくお待ちください"
      ref="loading"
    />
    <!-- エラー時にエラーモーダルを表示 -->
    <AlertForApp
        ref="AlertForApp"
        :message="alertMessage"
        :subMessage="alertSubMessage"
        :errorFlag="errorFlag"
        @confirmFinished="confirmFinished"
    />
  </div>
</template>
<script>
const apiUrl = process.env.VUE_APP_API_apiUrl;
const logoutUrl = process.env.VUE_APP_LOGOUT;
import LoadingBoxForApp from './components/parts/LoadingBoxForApp.vue'
import AlertForApp from './components/modal/AlertForApp'

export default {
    name: 'App',
    data: function(){
        return{
          // APIをコールする際に一時的にバッファする
          infoCallingApi: null,
          // 端末グループ取得APIで取得した端末グループ
          sites: null,
          // 端末取得APIで取得した端末一覧
          cameras : null,
          // 端末グループ、端末情報取得API実行時にエラーがあった場合に詳細情報を格納
          alertMessage: '',
          alertSubMessage: '',
          errorFlag: false,
        }
    },
    methods:{
        loadStart: function() {
          this.$refs.loading.loading_start();
        },
        loadFinish: function(){
          this.$refs.loading.loading_finish();
        },
        //**********************************************************/
        // 端末グループ情報取得API
        /**********************************************************/
        callApiForGetGroupInfo: async function(param, queries){
            await this.$store.dispatch('requestApi/getApiInfoAction', {
                url: apiUrl + param,
                params: queries
            })
            // 以下「eslint-disable-line」を使用することにより、不要なバリデーションを除外する
            .then(response => { // eslint-disable-line
                window.localStorage.removeItem('relogin_count');
                this.sites = this.$store.getters['requestApi/getApiInfo'];
                // 各種機能の権限対応のためにstoreにユーザーロールを保存する
                this.$store.commit('auth/setRoleId', this.sites[0].role_id);
                // 各種機能の権限対応のためにstoreにユーザー権限種別を保存する
                this.$store.commit('auth/setAuthTypeId', this.sites[0].auth_type_id);
            }, error => {// eslint-disable-line
                if (error == "Error: Request failed with status code 401") {
                    this.showResultMessage({
                        transitionLogoutPageFlg: true,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"エラー",
                        sub_message:"ログインし直してください。",
                        errorFlag: true
                    });
                } else if (error == "Error: Request failed with status code 403") {
                    if (sessionStorage.getItem('relogin_count')) {
                        if (Number(sessionStorage.getItem('relogin_count')) > 0) {
                            this.showResultMessage({
                                transitionLogoutPageFlg: true,
                                transitionTopPageFlg: false,
                                execFlg: false,
                                message:"権限エラー",
                                sub_message:"アクセス権がありません。",
                                errorFlag: true
                            });
                        } else {
                            this.$router.replace({ name: 'Relogin'});
                        }
                    } else {
                        this.$router.replace({ name: 'Relogin'});
                    }
                } else {
                    this.showResultMessage({
                        transitionLogoutPageFlg: true,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"端末情報取得エラー",
                        sub_message:"端末情報を取得できませんでした。",
                        errorFlag: true
                    });
                }
            })
        },
        //**********************************************************/
        // 端末情報取得API
        /**********************************************************/
        callApiForGetTermsInfo: async function(param, queries){
            await this.$store.dispatch('requestApi/getApiInfoAction', {
                url: apiUrl + param,
                params: queries
            })
            // 以下「eslint-disable-line」を使用することにより、不要なバリデーションを除外する
            .then(response => { // eslint-disable-line
                this.cameras = this.$store.getters['requestApi/getApiInfo'];
            }, error => {// eslint-disable-line
                if (error == "Error: Request failed with status code 401") {
                    this.showResultMessage({
                        transitionLogoutPageFlg: true,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"エラー",
                        sub_message:"ログインし直してください。",
                        errorFlag: true
                    });
                } else if (error == "Error: Request failed with status code 403") {
                    this.showResultMessage({
                        transitionLogoutPageFlg: true,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"権限エラー",
                        sub_message:"アクセス権がありません。",
                        errorFlag: true
                    });
                } else {
                    this.showResultMessage({
                        transitionLogoutPageFlg: true,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"端末情報取得エラー",
                        sub_message:"端末情報を取得できませんでした。",
                        errorFlag: true
                    });
                }
            })
        },
        //**********************************************************/
        // ログインリフレッシュのAPIの実施
        /**********************************************************/
        callApiForPostInfo: async function(param, queries){
            // 関数return値を配置する変数
            var isApiData = "";
            await this.$store.dispatch('requestApi/postApiInfoAction', {
                url: apiUrl + param,
                params: queries
            })
            // 以下「eslint-disable-line」を使用することにより、不要なバリデーションを除外する
            .then(response => { // eslint-disable-line
                this.infoCallingApi = this.$store.getters['requestApi/postApiInfo'];
                isApiData = this.infoCallingApi;
            }, error => {// eslint-disable-line
            })
            return isApiData
        },
        //**********************************************************/
        // ページタイトルを設定
        /**********************************************************/
        createPageTitle: function(to){
            if(to.meta.title){
                document.title = to.meta.title;
            }
        },
        //**********************************************************/
        // 確認モーダル表示のためのデータの受け渡し
        /**********************************************************/
        showResultMessage(result) {
            this.$refs.AlertForApp.showConfirm();
            this.alertMessage = result.message;
            this.alertSubMessage = result.sub_message;
            this.conrfirmResult = result
            this.errorFlag = result.errorFlag;
        },
        //**********************************************************/
        // AlertForApp.vueに関する処理
        /**********************************************************/
        confirmFinished() {
            if (this.conrfirmResult.transitionLogoutPageFlg) {
                window.localStorage.removeItem('TodoApp');
                sessionStorage.clear();
                window.location.href = logoutUrl;
            }
            if (this.conrfirmResult.transitionTopPageFlg) {
                window.location.href = '/home?site_no=' + this.$store.getters['auth/getSiteNo'];
            }
            if (this.conrfirmResult.execFlg) {
                this.getThumnailImageInfo();
            }
        },
        //**********************************************************/
        // 画面TOPまでスクロールをする
        /**********************************************************/
        scrollTop: function() {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        },
    },
    // インスタンスが生成され、データが初期化された後
    created: async function(){
      // アプリで表示対象の端末グループを設定
      if(this.$route.query.site_no !== undefined){
        this.$store.commit('auth/setSiteNo', this.$route.query.site_no)
      }

      // ログイン状態のチェック
      if(this.$route.meta["requiredAuth"] === true){
        let isLogin = false
        let session = sessionStorage.getItem('set_session');
        let sessionExpireTime = sessionStorage.getItem('set_session_exlire');

        // トークンがセットされていない場合にローカルストレージに保存されているかチェック
        if (session === null && sessionExpireTime === null ) {
          if (localStorage.getItem('TodoApp')) {
              const strageData = JSON.parse(localStorage.getItem('TodoApp'));
              if (strageData.auth.live_access_token && localStorage.getItem('set_local_exlire')) {
                  session = strageData.auth.live_access_token;
                  sessionExpireTime = localStorage.getItem('set_local_exlire');
              }
          }
        }

        // let sessionExpireTime = "1594965884"; // APIコールテスト用
        if (session !== null && sessionExpireTime !== null ) {
          this.$store.commit('auth/setLiveAccessToken', true) // ログイン対象のLIVEアクセストークン
          let queriesLiveAccessToken = { live_access_token: session };
          /**
           * セッション有効期限を確認するために必要な情報
           */ 
          let nowDateTime = new Date();
          // authAPIからstoreに格納されたセッションexpiredを取得
          let sessionExpireTimeConverted = new Date(sessionExpireTime * 1000);
          // 現在日付時刻とセッションexpiredとの差分を比較
          let diffSessionTime = Math.floor( ( sessionExpireTimeConverted.getTime() - nowDateTime.getTime() ) / ( 1000 * 60 * 60 ) );
          /**
           * セッション有効期限確認
           */
          // セッション有効期限が1時間以内の時
          if (diffSessionTime < 1) {
              let sessionReflesh = await this.callApiForPostInfo('auth/reflesh', queriesLiveAccessToken);
              // API実行成功時
              if (sessionReflesh) {
                  this.$store.commit('auth/setLiveAccessToken', sessionReflesh.live_access_token)
                  sessionStorage.setItem('set_session', sessionReflesh.live_access_token);
                  sessionStorage.setItem('set_session_exlire', sessionReflesh.expired_date);
                  isLogin = true;
              }
              // API実行失敗時
              else {
                  isLogin = false;
              }
          }
          // セッション有効期限内
          else {
              this.$store.commit('auth/setLiveAccessToken', session)
              isLogin = true;
          }
        }else{
          isLogin = false;
        }

        //**********************************************************/
        // ログイン状態なら端末グループ情報・端末情報取得用のAPIの実施
        /***********************************************************/
        if(isLogin){
          // 端末グループ情報の取得
          var queriesSites = {
            live_access_token : this.$store.getters['auth/getLiveAccessToken'],
            site_no : this.$store.getters['auth/getSiteNo'],
          };
          this.callApiForGetGroupInfo('sites/'+ this.$store.getters['auth/getSiteNo'], queriesSites);

          // 端末情報の取得
          var queriesTerms = {
            live_access_token : this.$store.getters['auth/getLiveAccessToken'],
          };
          this.callApiForGetTermsInfo('sites/' + this.$store.getters['auth/getSiteNo'] + '/terms', queriesTerms);
        }else{
          // FASTIO PF再ログイン画面へリダイレクト
          this.$router.replace({ name: 'Relogin'});
        }
      }
    },
    components: {
        LoadingBoxForApp,
        AlertForApp,
    },
    mounted () {
      // 端末情報を取得した時点でナビゲーションバーとヘッダーを表示する
      // mainBlockに対してはvisibilityの無効化して、非表示状態にする
      this.loadStart();

      var params = (new URL(document.location)).searchParams;
      var siteNoParam = params.get('site_no');
      sessionStorage.setItem('site_no', siteNoParam);

      // 初期表示時にルートの変更を検知できないのでページタイトルを設定する
      // floginの場合はタイトルを表示していない(必要に応じてrouter/index.jsを編集すること)
      if (this.$route.meta.title !== undefined) {
        document.title = this.$route.meta.title;
      }
    },
    watch: {
      // ルートの変更の検知
      $route (to, from) {// eslint-disable-line
        this.createPageTitle(to);
      }
    }
}

</script>
<style lang="scss" scoped>
@import "./assets/css/common.css";
@import "~fontsource-noto-sans-jp/index.css";
</style>
